import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "semantic-ui-react";

import { CompanyFeatures } from "utilities/dist/company/constants";
import { isCompanyFeatureActive } from "utilities/dist/company/helpers";

import { toggleRecommendationModal } from "./actions";
import { InvoiceRecommendationListContainer } from "./list.container";

export const InvoiceRecommendationButtonContainer = ({ customer }) => {
    const { isAiActive } = useSelector(({ auth }) => ({
        isAiActive: isCompanyFeatureActive(auth.user?.company, CompanyFeatures.AI),
    }));
    const dispatch = useDispatch();

    if (!isAiActive) return null;

    return (
        <>
            <InvoiceRecommendationListContainer customer={customer} />
            <Button
                onClick={() => dispatch(toggleRecommendationModal())}
                labelPosition="left"
                content="AI Recommendation"
                icon={{
                    name: "fire",
                }}
            />
        </>
    );
};
